const SANCTUM_TOKEN_KEY = 'sanctum.token'
const SANCTUM_TOKEN_OWNER_KEY = 'sanctum.token.owner'
const TAB_LOGGED_OUT_KEY = 'sanctum.token.tabLoggedOut'

// Drops a server-rejected credential from both storages by value, since it is dead for every tab.
// Returns whether it was this tab's own current token, by sanctumTokenStorage.get()'s precedence.
export const invalidateRejectedSanctumToken = (rejectedToken: string): boolean => {
  if (typeof window === 'undefined') return false
  const sessionToken = sessionStorage.getItem(SANCTUM_TOKEN_KEY)
  const wasSessionToken = sessionToken === rejectedToken
  if (wasSessionToken) sessionStorage.removeItem(SANCTUM_TOKEN_KEY)

  const wasLocalToken = localStorage.getItem(SANCTUM_TOKEN_KEY) === rejectedToken
  if (wasLocalToken) {
    localStorage.removeItem(SANCTUM_TOKEN_KEY)
    localStorage.removeItem(SANCTUM_TOKEN_OWNER_KEY)
  }

  const selectsRememberedToken =
    sessionToken === null && sessionStorage.getItem(TAB_LOGGED_OUT_KEY) === null
  const wasCurrentToken = wasSessionToken || (selectsRememberedToken && wasLocalToken)
  if (wasCurrentToken) sessionStorage.setItem(TAB_LOGGED_OUT_KEY, 'true')
  return wasCurrentToken
}
